import {Form, Input, message, Modal, ModalProps} from 'antd';
import React from 'react';
import Style from './index.module.scss';
import useRequestFn from '../../../../../Utils/Hooks/useRequestFn';
import {errorMessage} from '../../../../../Utils/common';
import {editWebSite, WebSiteEntityItem} from '../../service';

interface Props extends ModalProps {
    data?: WebSiteEntityItem;
    onOk: () => void;
}

const Index = ({data, onOk, ...props}: Props) => {
    const [form] = Form.useForm<WebSiteEntityItem>();
    const [save, {loading: saveLoading}] = useRequestFn(editWebSite);

    async function onFinish(formData: WebSiteEntityItem) {
        try {
            if (data) {
                formData.id = data.id;
            }
            await save(formData);
            message.success('编辑成功!');
            onOk();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    return (
        <Modal
            {...props}
            width={600}
            title="编辑网站"
            confirmLoading={saveLoading}
            onOk={form.submit}>
            <div className={Style.root}>
                <Form
                    form={form}
                    onFinish={onFinish}
                    labelCol={{span: 5}}
                    initialValues={data}>
                    <Form.Item
                        name="sitename"
                        label="网站名称"
                        rules={[{required: true}]}>
                        <Input placeholder="请输入" />
                    </Form.Item>
                    <Form.Item
                        name="baseDomainUrl"
                        label="域名"
                        rules={[
                            {required: true},
                            {
                                pattern: /^(http:\/\/|https:\/\/).*$/,
                                message: '必须以http://或https://开头',
                            },
                        ]}>
                        <Input placeholder="请输入完整域名 例如: https://www.edufe.com" />
                    </Form.Item>
                </Form>
            </div>
        </Modal>
    );
};

export default Index;
